import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
} from "@/components/ui/dialog"

import { cn } from "@/lib/cn"
import { Translate } from "./translate"
import { Button } from "./ui/button"
import { I18nDialogHeader } from "./ui/i18n-dialog-header"
import { Img } from "./ui/image"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type LabelsConfigType = {
  titleLbl: string
  bodyTitleLbl?: string
  bodyTextLbl: string
  bodyTextLblData?: Record<string, string | number>
  buttonLbl: string
}

type InfoDialogProps = LabelsConfigType & {
  iconSrc: string
  onClick: () => void
  handleClose: () => void
}
/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
const InfoDialog = ({
  bodyTextLbl,
  bodyTitleLbl,
  buttonLbl,
  iconSrc,
  titleLbl,
  bodyTextLblData,
  onClick,
  handleClose,
}: InfoDialogProps) => {
  return (
    <Dialog open={true} onOpenChange={handleClose} modal>
      <DialogContent>
        <I18nDialogHeader i18nTitle={titleLbl} />
        <DialogBody className="text gap-4">
          <Img
            alt="status-icon"
            src={iconSrc}
            width={52}
            height={52}
            className="mx-auto"
          />
          {bodyTitleLbl && (
            <h2 className="font-primary text-title-l font-extrabold">
              <Translate i18nKey={bodyTitleLbl} />
            </h2>
          )}
          <p className="text">
            <Translate i18nKey={bodyTextLbl} values={bodyTextLblData} />
          </p>
        </DialogBody>
        <DialogFooter
          className={cn(
            window.APP_VENDOR === "snai" ? "justify-end" : "justify-center",
          )}
        >
          <Button onClick={onClick} type="submit" size="dialogSubmit">
            <Translate i18nKey={buttonLbl} />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { InfoDialog }
export type { LabelsConfigType }
